import { render, staticRenderFns } from "./Columnas.vue?vue&type=template&id=592c6ba5&"
import script from "./Columnas.vue?vue&type=script&lang=js&"
export * from "./Columnas.vue?vue&type=script&lang=js&"
import style0 from "./Columnas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports